import request from '@/utils/request'
import Utils from '@/utils/util'
let wConfig = Utils.getConfig()
export function generateRequest(data, obj, variable) {
    let new_data = data
    if (obj.param) {
        new_data = Object.assign(obj.param, data)
    }
    return request({
        url: obj.url || '',
        method: obj.method || 'post',
        responseType: obj.responseType || 'json',
        baseURL: obj.baseURL || wConfig.VUE_APP_BASE_API,
        apiType: obj.apiType || '',
        data: new_data,
        ...variable
    })
}

